import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'schools.resources.hero.heading',
		defaultMessage: 'Resources',
		description: 'Calm Schools Resources hero title',
	},
	bodyText: {
		id: 'schools.resources.hero.bodyText',
		defaultMessage: 'Free tools for resilient classrooms',
		description: 'Calm Schools Resources herobody text',
	},
});
